import { Controller } from "@hotwired/stimulus"
import { destroy } from "@rails/request.js"

// Resume-draft banner in the configurator. Dismissing it clears the saved
// draft so the banner doesn't reappear on the next visit.
export default class extends Controller {
  static values = { url: String }

  dismiss() {
    destroy(this.urlValue)
    this.element.remove()
  }
}
